import { render, staticRenderFns } from "./insufficient-funds.vue?vue&type=template&id=cea41c86&"
import script from "./insufficient-funds.vue?vue&type=script&lang=js&"
export * from "./insufficient-funds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports